import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMenu } from "../context/useMenu";
import { hasStoredIdentity, hasUnlockedVault } from "./APIClient";
import FullPageLoader from "./FullPageLoader";

const ProtectedRoute = ({ path }: { path: string }) => {
  const { hasAccess, loading } = useMenu();
  const location = useLocation();

  if (!hasStoredIdentity()) {
    return <Navigate to="/login" replace />;
  }

  if (!hasUnlockedVault()) {
    return (
      <Navigate
        to="/unlock"
        replace
        state={{ returnTo: `${location.pathname}${location.search}` }}
      />
    );
  }

  // Show loading state while fetching menu data
  if (loading) {
    return (
       <FullPageLoader/>
    );
  }

  if (!hasAccess(path)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // User has access, render the child route
  return <Outlet />;
};

export default ProtectedRoute;
